<template>
  <div class="stepOneMain">
    <div class="scroll_wrap">
      <span style="color: #F56C6C;">温馨提醒：如果一场赛事存在多个场次，请点击“+”号添加多个比赛场次信息。赛事提交以后，例如五个比赛场次，系统会自动增加五个比赛报告。</span>
      <vue-scroll ref="scroll">
        <el-form
          ref="plainInfo"
          :model="plainInfo"
          :rules="formRules"
          label-width="180px"
          class="black_form"
        >
          <div class="player-list-wrapper" v-for="(playerItem, index) in plainInfo.reports" :key="index">
            <fieldset class="vita-form-fieldset" style="border: 1px dashed white;padding: 10px ; margin-bottom: 15px"  >
              <legend>比赛场次{{index+1}}</legend>
              <div class="left-box">
                <el-form-item :label="'比赛对手 '+(index+1)" :prop="`reports.${index}.vs`" :rules="[{ required: true, message: '必填项' }]">
                  <el-input
                    v-model="playerItem.vs"
                    class="w445"
                    placeholder="请输入比赛对手"
                    maxlength="100"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item label="比赛地点" :prop="`reports.${index}.matchPlace`" :rules="[{ required: true, message: '必填项' }]">
                  <el-input
                    v-model="playerItem.matchPlace"
                    class="w445"
                    placeholder="请输入比赛地点"
                    maxlength="100"
                    show-word-limit
                  ></el-input>
                </el-form-item>

                <el-form-item label="开场时间" :prop="`reports.${index}.matchTime`" :rules="[{ required: true, message: '必填项' }]">
                  <el-date-picker
                    v-model="playerItem.matchTime"
                    class="w445"
                    type="datetime"
                    placeholder="请选择开场时间"
                    value-format="timestamp"
                    :editable="false"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="比赛时长" :prop="`reports.${index}.matchTotalTime`" :rules="[{ required: true, message: '必填项' }]">
                  <el-input
                    v-model="playerItem.matchTotalTime"
                    style="width: 100px; margin-right: 10px"
                  ></el-input
                  >分钟
                </el-form-item>

                <el-form-item label="天气" :prop="`reports.${index}.weather`" :rules="[{ required: true, message: '必填项' }]">
                  <el-select
                    v-model="playerItem.weather"
                    class="w445"
                    placeholder="请选择天气"
                  >
                    <el-option
                      v-for="(item, index) in weatherList"
                      :key="index"
                      :label="item.name"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="主要阵型" :prop="`reports.${index}.teamFormation`" :rules="[{ required: true, message: '必填项' }]">
                  <el-select
                    v-model="playerItem.teamFormation"
                    class="w445"
                    placeholder="请选择主要阵型"
                  >
                    <el-option
                      v-for="(item, index) in teamFormationList"
                      :key="index"
                      :label="item.name"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <div style="display: flex">
                  <el-form-item label="比赛结果" :prop="`reports.${index}.matchResult`" :rules="[{ required: true, message: '必填项' }]">
                    <el-select
                      v-model="playerItem.matchResult"
                      class="w150"
                      placeholder="请选择比赛结果"
                    >
                      <el-option
                        v-for="(item, index) in matchResultList"
                        :key="index"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label-width="10px" >
                    进球
                    <el-input-number controls-position="right" v-model="playerItem.goalScore"  :min="0" :max="50"  style="width: 90px; margin-right: 10px;margin-left: 10px;" label="进球数"></el-input-number>：
                  </el-form-item>
                  <el-form-item label-width="10px" >
                    失球
                    <el-input-number controls-position="right" v-model="playerItem.goalConceded"  :min="0" :max="50"  style="width: 90px; margin-right: 10px;margin-left: 10px;" label="失球数"></el-input-number>
                  </el-form-item>
                </div>

                <el-form-item label="比赛总结" :prop="`reports.${index}.matchSummary`" :rules="[{ required: true, message: '必填项' }]">
                  <el-input
                    v-model.trim="playerItem.matchSummary"
                    :rows="3"
                    placeholder="请输入比赛总结"
                    type="textarea"></el-input>
                </el-form-item>
              </div>
              <div class="right-box">
                <div v-if="!(plainInfo.reports.length === 1 && index == 0)">
                  <el-button type="danger" icon="el-icon-remove-outline" circle @click="handleDeletePlayerList(index)"></el-button>
                </div>
                <div style="margin-top: 10px">
                  <el-button type="success" icon="el-icon-circle-plus-outline" circle @click="handleAddPlayerList"></el-button>
                </div>
              </div>
            </fieldset>
          </div>



        </el-form>
      </vue-scroll>
    </div>
    <div class="next_btn_wrap">
      <el-button
        type="primary"
        style="margin-right: 0.2rem"
        @click="saveData('temporarily')"
        >暂时保存</el-button
      >
      <el-button
        type="primary"
        style="margin-right: 0.2rem"
        :loading="saveBtn"
        @click="saveData('next')"
        >下一步</el-button
      >
      <el-button type="danger" @click="showTip = true">取消</el-button>
    </div>
    <yioks-tip
      :showTip="showTip"
      :tipMsg="$t('waivedSubmission')"
      @callback="goBack"
    ></yioks-tip>
    <yioks-tip
      :showTip="temporarily"
      :tipMsg="tips"
      @callback="saveTemporarily"
    ></yioks-tip>
    <yioks-tip
      :showTip="confirmSubmit"
      :tipMsg="confirmTips"
      @callback="confirmSave"
    ></yioks-tip>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; // 富文本编辑器，下面的样式必须引入
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import common from "@/api/common";
import match from "@/api/match";
import record from "@/api/record";
import storage from "@/utils/storage";
export default {
  components: {
    quillEditor,
    Pagination: () => import("@/components/Pagination"),
    "yioks-sspviewer": () => import("@/components/sspViewer/sppCanvas"),
    FlashTips: () => import("@/components/FlashTips"),
  },
  data() {
    return {
      // 表单信息
      tips: "确定暂时保存并返回吗?",
      confirmSubmit: false, // 确认提交
      confirmTips: "确定保存并进入下一步吗?",
      plainInfo: {
        uuid:"",
        reports:[
          {
            vs: "", // 比赛对手
            matchPlace: "", // 比赛地点
            matchTime: "", // 开场时间
            matchTotalTime: 0, // 比赛总时长
            weather: "", // 天气
            teamFormation: "", // 主要阵型
            goalScore: 0, // 进球
            goalConceded: 0, // 失球
            matchResult: "", // 比赛结果
            matchSummary: "", // 总结
            uuid: "", // 总结
          }
        ],
      },

      // 天气
      weatherList: [
        {name: "晴", value: "晴",},
        {name: "多云", value: "多云",},
        {name: "阴", value: "阴",},
        {name: "阵雨", value: "阵雨",},
        {name: "小雨", value: "小雨",},
        {name: "中雨", value: "中雨",},
        {name: "大雨", value: "大雨",},
        {name: "雨夹雪", value: "雨夹雪",},
        {name: "小雪", value: "小雪",},
        {name: "中雪", value: "中雪",},
        {name: "大雪", value: "大雪",},
      ],
      // 比赛结果
      matchResultList: ["胜", "平", "负"],
      // 主要阵型
      teamFormationList: [
        { name: "4-4-2", value: "4-4-2" },
        { name: "4-4-2(D)", value: "4-4-2(D)" },
        { name: "4-5-1", value: "4-5-1" },
        { name: "4-3-3", value: "4-3-3" },
        { name: "4-2-3-1", value: "4-2-3-1" },
        { name: "4-1-4-1", value: "4-1-4-1" },
        { name: "4-1-3-2", value: "4-1-3-2" },
        { name: "4-4-1-1", value: "4-4-1-1" },
        { name: "3-1-5-1", value: "3-1-5-1" },
        { name: "3-2-3-1-1", value: "3-2-3-1-1" },
        { name: "3-1-4-2", value: "3-1-4-2" },
        { name: "5-3-2", value: "5-3-2" },
        { name: "5-3-1-1", value: "5-3-1-1" },
        { name: "1-4-4-1", value: "1-4-4-1" },
        { name: "3-2-2-3", value: "3-2-2-3" },
        { name: "3-5-1-1", value: "3-5-1-1" },
        { name: "3-5-2", value: "3-5-2" },
        { name: "3-4-3", value: "3-4-3" },
        { name: "5-4-1", value: "5-4-1" },
        { name: "3-3-1", value: "3-3-1" },
        { name: "3-1-3", value: "3-1-3" },
        { name: "3-2-2", value: "3-2-2" },
        { name: "2-3-2", value: "2-3-2" },
        { name: "4-2-1", value: "4-2-1" },
        { name: "4-1-2", value: "4-1-2" },
        { name: "1-2-1", value: "1-2-1" },
        { name: "3-1", value: "3-1" },
        { name: "1-3", value: "1-3" },
        { name: "2-2", value: "2-2" },
      ],
      uploadErroeMsg: "", // 文件上传信息校验
      uploadFileList: [], // 文件上传组件 - 文件列表
      uploadFileList_edit: [], // 文件上传组件 - 编辑中新增文件
      uploadPath: "/api/zuxie/guozi/upload/uploadJixiaoFile",
      // 表单验证规则
      formRules: {
        matchType: [{ required: true, message: "请选择赛事性质", trigger: "change" }],
        tournamentName: [{ required: true, message: "请输入赛事名称", trigger: "blur" }],
        squadNowName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        tournamentPlace: [{ required: true, message: "请输入赛事地点", trigger: "blur" }],
        matchTime: [{ required: true, message: "请选择开始时间", trigger: "change" },],
        endTime: [{ required: true, message: "请选择结束时间", trigger: "change" },],
        matchTotalTime: [{ required: true,
          validator: (rule, value, callback) => {
            if (value === null || value === undefined || value === "") {
              callback(new Error('请输入赛事时长'))
            } else {
              if (/^[0-9]{1,3}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入0-999内的赛事时长'))
              }
            }
          },
          trigger: 'blur' }],
        weather: [{ required: true, message: "请选择赛事天气", trigger: "change" },],
        teamFormation: [{ required: true, message: "请选择主要阵型", trigger: "change" },],
        squadResult: [{ required: true, message: "请选择赛事结果", trigger: "change" },],
        squadLevel: [{ required: true, message: "请选择", trigger: "change" },],
        squadSex: [{ required: true, message: "请选择", trigger: "change" },],
        recordUuid: [{ required: true, message: "请选择", trigger: "change" },],
//        goalScore: [{
//          required: false,
//          validator: (rule, value, callback) => {
//            if (value === null || value === undefined || value === "") {
//              callback(new Error('请输入进球数'))
//            } else {
//              if (/^[0-9]{1,3}$/.test(value)) {
//                callback()
//              } else {
//                callback(new Error('请输入0-999内的进球数'))
//              }
//            }
//          },
//          trigger: 'blur'
//        }],
//        goalConceded: [{
//          required: false,
//          validator: (rule, value, callback) => {
//            if (value === null || value === undefined || value === "") {
//              callback(new Error('请输入失球数'))
//            } else {
//              if (/^[0-9]{1,3}$/.test(value)) {
//                callback()
//              } else {
//                callback(new Error('请输入0-999内的失球数'))
//              }
//            }
//          },
//          trigger: 'blur'
//        }],
      },


      // vue-edit 设置，只需要三个
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline"], // 加粗 斜体 下划线 删除线
          ],
        },
        placeholder: this.$t("defaultPlaceholder"),
      },
      userRole: storage.get("userInfo").userRole, // 登录角色
      idx: 0, // 第几个环节
      showTip: false, // 取消提示
      squadInfo: {}, // 球队的详情
      temporarily: false, // 暂时保存提示
      data: "", // 需要保存的数据
      tournamentUuid: this.$route.query.uuid,
      saveBtn: false, // 下一步按钮 loading
      squadLevelList:[],
      squadLevelMale:[],
      squadLevelFemale:[],
      squadLevelMixed:[],
      squadType:[],
      squadLevel:[],
      recordList:[],
      recordToScoreList: [], // 配置得分
      recordToSquadList: [], // 配置球队

    };
  },

  computed: {
  },

  watch: {
  },
  created() {

    if (this.tournamentUuid ) this.getMatchReportInfo();
  },
  methods: {
    handleAddPlayerList() {
      let { reports } = this.plainInfo;
      reports.push({
        vs: "", // 比赛对手
        matchPlace: "", // 比赛地点
        matchTime: "", // 开场时间
        matchTotalTime: 0, // 比赛总时长
        weather: "", // 天气
        teamFormation: "", // 主要阵型
        goalScore: 0, // 进球
        goalConceded: 0, // 失球
        matchResult: "", // 比赛结果
        matchSummary: "", // 总结
        uuid: "",
      });
      this.$set(this.plainInfo, "reports", reports);
    },
    handleDeletePlayerList(index) {
      let { reports } = this.plainInfo;
      reports.splice(index, 1);
      this.$set(this.plainInfo, "reports", reports);
    },

    // 当存在 matchReportUuid 存在时，代表编辑，请求回显数据
    getMatchReportInfo() {
      match.matchTournamentTwoInfo(this.tournamentUuid).then((res) => {
        if (res.code) {
          this.$message.error(res.msg);
          this.$router.push("/home/index");
        } else {

          this.plainInfo.tournamentUuid  = this.tournamentUuid ;
          if(res.length>0){
            this.plainInfo.reports = res;
          }
        }
      });
    },
    // 球队信息
    // 返回
    goBack(isShow) {
      if (isShow) {
        this.$router.go(-1);
      }
      this.showTip = false;
    },
    // 下一步，保存数据
    saveData(val) {
      this.$refs["plainInfo"].validate((valid) => {
        if (valid) {
          this.data = {
            tournamentUuid : this.tournamentUuid ,
            reports: this.plainInfo.reports
          }
          if (val === "temporarily") {
            this.temporarily = true;
          } else {
            this.saveBtn = true;
            this.confirmSubmit = true;
          }
        }
      });
    },
    // 暂时保存并返回列表
    saveTemporarily(isSure) {
      if (isSure) {
        match.TwoMatchReportTournament(this.data).then((res) => {
          this.$router.push({
            path: "list_tournament",
            query: {},
          });
        });
      } else {
        this.temporarily = false;
      }
    },
    // 确定保存并返回列表
    confirmSave(isSure) {
      if (isSure) {
        match.TwoMatchReportTournament(this.data).then((res) => {
            if (res.code) {
              this.$message.error(res.msg);
              this.saveBtn = false;
              this.confirmSubmit = false;
            } else {
              this.saveBtn = false;
              this.confirmSubmit = false;
              this.$emit("changeNav", {
                jump: 2,
                uuid: res.uuid,
                tournamentReportStatus: res.tournamentReportStatus,
              });
            }
          })
          .catch((err) => {
            this.confirmSubmit = false;
            this.saveBtn = false;
          });
      } else {
        this.confirmSubmit = false;
        this.saveBtn = false;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.stepOneMain
  display flex
  justify-content space-between
  flex-direction column
  height 590px
  .scroll_wrap
    height 540px
    padding 20px 10px
    background-color $black_color
    overflow hidden
    .w445
      width: 445px;
    .w150
      width: 150px;
    .player-list-wrapper
      width 95%
      display flex
      justify-content space-around
      border-bottom 1px dashed #ccc
      border-top 1px dashed #ccc
      padding 20px 20px 0px 0px
      margin-bottom 20px
      .vita-form-fieldset
        width 100%
        display flex
        .left-box
          width 100%
        .right-box
          width 40px
          display flex
          justify-content center
          flex-direction column
          align-items center


  .next_btn_wrap
    width 100%
    display flex
    justify-content center
.plan-upload
  /deep/.el-upload__tip
    color #fff !important
.hide-upload
  /deep/.el-upload--picture-card
    display none !important
    // visibility hidden !important
    transition all 0.5s
.el-radio
  color white
</style>
<style lang="stylus" scoped>
  .yioks-switch-grey
    /deep/ .el-switch__label.is-active
      color: #13ce66 !important
    /deep/ .el-switch__label:not(.is-active)
      color: #ccc !important
</style>
